//https://api.iconify.design/fa/play.svg
import { Controller } from '@hotwired/stimulus'

export default class Icon extends Controller {
  static iconsLoaded = {}
  static values = {
    library: String,
    name: String,
    visible: Boolean, //LUCIAN added this line for task "Selected state not being removed when userData is reseted from another page"
  }
  declare readonly libraryValue: string
  declare readonly nameValue: string
  isSVGElement: boolean

  async connect() {
    this.visibleValueChanged()
  }

  disconnect() {
    this.element.innerHTML = ''
  }

  async getIcon() {
    const library = Icon.iconsLoaded[this.libraryValue] || {}
    const icon = library[this.nameValue]
    if (icon) {
      return icon
    }

    try {
      const response = await fetch(
        `https://api.iconify.design/${this.libraryValue}/${this.nameValue}.svg`
      )
      const text = await response.text()
      library[this.nameValue] = text
      Icon.iconsLoaded[this.libraryValue] = library
      return text
    } catch (error) {
      console.error(error)
    }
  }

  setElementProps(text: string) {
    const isSVG = this.element.tagName === 'svg'
    if (isSVG) {
      this.isSVGElement = true
      const container = document.createElement('div')
      container.innerHTML = text

      const childNode = container.firstElementChild
      if (childNode) {
        if (childNode.hasAttributes()) {
          const attrs = childNode.attributes
          for (let i = attrs.length - 1; i >= 0; i--) {
            const { name, value } = attrs[i]
            this.element.setAttribute(name, value)
          }
        }
        this.element.innerHTML = childNode.innerHTML
      }
    } else {
      this.element.innerHTML = text
    }
  }
  //LUCIAN added following code for task "Selected state not being removed when userData is reseted from another page"
  async visibleValueChanged() {
    const visible = this.element.getAttribute('data-icon-visible-value')

    if (visible !== 'false') {
      const icon = await this.getIcon()
      this.setElementProps(icon)
    } else {
      this.element.innerHTML = ''
    }
  }
  //LUCIAN added following code for task "Selected state not being removed when userData is reseted from another page"
}
// ;<svg
//   xmlns="http://www.w3.org/2000/svg"
//   xmlns:xlink="http://www.w3.org/1999/xlink"
//   width="1em"
//   height="1em"
//   preserveAspectRatio="xMidYMid meet"
//   viewBox="0 0 512 512"
//   style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"
// >
//   <path
//     fill="currentColor"
//     d="M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19C8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91a12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z"
//   />
// </svg>
